import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router';

import Button from '../components/button';
import { TabQueryParameters } from '../navigation';
import { Block } from '@williamhill/rosi-ui-shared/src/components/typography';

export default function NoTicketsComponent({ selectedTab }: { selectedTab: TabQueryParameters }) {
  const history = useHistory();

  return (
    <Container weight="bold">
      {selectedTabText[selectedTab]}
      <TrackNewBetButton onClick={() => history.push('/')} text="Track a New Bet" modifiers="secondary" />
    </Container>
  );
}

const Container = styled(Block)`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  gap: 2rem;
`;

const selectedTabText: Record<TabQueryParameters, string> = {
  open: 'You are not currently tracking any active bets',
  settled: 'There are no settled bets to show'
};

const TrackNewBetButton = styled(Button)`
  width: fit-content;
  font-weight: 600;
`;
